import { ReactComponent as DeleteActionSvg } from "../../assets/images/svgs/deleteAction.svg";

const DeleteActionIcon = ({ className = "", ...props }) => {
  return (
    <DeleteActionSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default DeleteActionIcon;
